export const friendKeys = {
	all: ["friends"] as const,
	lists: () => [...friendKeys.all, "list"] as const,
	list: (userId: number) => [...friendKeys.lists(), userId] as const,
} as const
